import Vue from 'vue';
import { cloudfrontURL, baseURL, formURL } from '@/utils/urlBuilder';

Vue.prototype.$baseURL = baseURL;
Vue.prototype.$formURL = formURL;
Vue.prototype.$cloudfrontURL = cloudfrontURL;
